import {
  AppBar,
  Box,
  Card,
  InputBase,
  Select,
  Stack,
  styled,
  Typography,
} from '@mui/material';
import { Section } from '@rumblefish/ui/src/components/Rumblefish23Theme';

export const StyledSection = styled(Section)(() => ({
  position: 'relative',
}));

export const StyledStack = styled(Stack)(({ theme }) => ({
  padding: theme.spacing(0, 0, 9, 0),
  width: '100%',
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(8),
  [theme.breakpoints.down('md')]: {
    padding: theme.spacing(0, 0, 5, 0),
    gap: theme.spacing(4),
  },
  [theme.breakpoints.down('md')]: {
    padding: theme.spacing(0, 0, 9, 0),
    gap: theme.spacing(4),
  },
}));

export const StyledCard = styled(Card)(({ theme }) => ({
  background: 'linear-gradient(37deg, #080808, #1c1c1c)',
  maxWidth: '550px',
  marginInline: 'left',
  marginTop: '2rem',
  borderRadius: '1.5rem',
  filter: 'brightness(90%)',

  [theme.breakpoints.down('md')]: {
    flexDirection: 'column',
    marginInline: 'auto',
  },
}));

export const StyledInputBase = styled(InputBase)(({ theme }) => ({
  color: 'inherit',
  padding: theme.spacing(0.5, 2),
  border: '1px solid #242a30',
  borderRadius: '0.8rem',
  backgroundColor: '#242a30',
  width: '100%',
}));

export const NavbarContainer = styled(Box)(({ theme }) => ({
  marginBottom: theme.spacing(4),
}));

export const StyledAppBar = styled(AppBar)(({ theme }) => ({
  position: 'static',
  background: 'linear-gradient(135deg, #141A21 0%, #141A21 100%)',
  boxShadow: 'none',
  borderRadius: '1rem',
  marginTop: '3rem',
  marginBottom: '-2rem',
  paddingBlock: '0.5rem',
  [theme.breakpoints.down('md')]: {
    paddingBlock: '1rem',
  },
}));

export const StyledSelect = styled(Select)(({}) => ({
  backgroundColor: '#242a30',
  borderRadius: '0.8rem',
  color: 'white',
  '& .MuiSelect-icon': {
    color: 'white',
  },
  '&.Mui-focused': {
    '& .MuiOutlinedInput-notchedOutline': {
      borderColor: '#A0C4FF !important',
      borderWidth: '1px',
    },
  },
  '&:hover .MuiOutlinedInput-notchedOutline': {
    borderColor: 'rgba(160, 196, 255, 0.7)',
  },
  '& .MuiOutlinedInput-notchedOutline': {
    borderColor: 'rgba(255, 255, 255, 0.23)',
  },
}));

export const StyledMenu = styled('div')({
  backgroundColor: '#242a30',
  '& .MuiMenuItem-root': {
    color: 'white',
    '&.Mui-selected': {
      backgroundColor: '#A0C4FF',
    },
    '&.Mui-selected:hover': {
      backgroundColor: '#A0C4FF',
    },
    '&:hover': {
      backgroundColor: '#3a3f47',
    },
  },
});

export const StyledInfo = styled(Typography)(({}) => ({
  background: 'linear-gradient(to right, #ffffff, #d0d0d0)',
  WebkitBackgroundClip: 'text',
  color: 'transparent',
  fontSize: '18px',
  textAlign: 'center',
  marginBlock: '10px',
}));
